/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import action from '../../Redux Store/actions';
import cssClasses from './Leads.module.css';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import PlusIcon from '../Icons/PlusIcon';
import DropDown from '../../Subcomponents/DropDown';
import SearchBar from '../../Subcomponents/Search';
import Button from '../../Subcomponents/Button';
import Leadcard from '../../Subcomponents/Leadcard';
import LostLeads from './LostLeads/LostLeads';

//*icons
import dropDownIcon from '../../Assets/Images/Common/dropDownIcon.svg';
import checked from '../../Assets/Images/Common/checked.svg';
import AddLead from '../../Modals/AddLead/AddLead';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import DateComponent from '../../Subcomponents/DateComponent';
import { useNavigate, useSearchParams } from 'react-router-dom';
import ClickAwayListener from '@mui/material/ClickAwayListener';

import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
//Modal

import InfiniteScroll from 'react-infinite-scroll-component';
// Icons
import EmptyListIcon from '../../Assets/Images/Common/EmptyListLeads.svg';
//services
import {
  getLeadsFromRpc,
  updateLeadStatus,
  updateLeadForClaim,
  updateLeadResponse,
  getProjects,
  getUsers,
  addLeadLogs,
  getUsersForTeamLead,
  getProjectsForLeadFilter,
  sendWhatsappMessageOnLeadClaimed,
  updateMultipleLeadForClaim,
  updateMultipleLeadStatus,
  addMultipleLeadLogs,
  overrideStaleApprovalStatuses,
} from '../../Services/Lead';
import { getAllCpForLaunch } from '../../Services/ChannelPartner';
import { presentLoader, dismissLoader } from '../../Services/loader';
import { errorTost, offlineToast, successTost } from '../../Services/Toast';

import debounce from 'lodash.debounce';
import { findIndex, orderBy, sortBy, uniqBy } from 'lodash';
import { Network } from '@capacitor/network';
import { supabase } from '../../supabaseClient';
import { Box } from '@mui/material';
import ThreeDotsMenu from '../../Subcomponents/ThreeDotsMenu';
import ReAssignLead from '../../Modals/ReAssignLead/ReAssignLead';

export default function Leads() {
  let loggedInUser = {};
  loggedInUser = useSelector((state) => state.Auth.user);
  const [tabs, setTab] = useState([
    'Unclaimed',
    'Nuturing',
    'Site Visit',
    'Token',
    'Allotment',
    'Agreement Done',
    'All',
    'Lost',
  ]);

  
  const [drpDownSelectedVal, setDrpDownSelectedVal] = useState('Latest First');
  // const [tabValue, setTabValue] = React.useState('Unclaimed');
  // const [sendTabValue, setSendTabValue] = useState('Unclaimed');
const [tabValue, setTabValue] = useState(sessionStorage.getItem('LeadName') ? 'All' : 'Unclaimed');
  const [sendTabValue, setSendTabValue] = useState(sessionStorage.getItem('LeadName') ? 'All' : 'Unclaimed');
  const [leadObj, setLeadObj] = useState({
    person: {
      name: 'Raj Lenka',
    },
    id: 'VJ001',
    createdAt: 1663747450294,
    last_updated_at: 1663747450294,
    type: 'Web',
    status: 'unclaimed',
    leadStatus: 'WARM',
    FOS: {
      name: 'Mr. Chris Broad',
    },
    CP: {
      name: 'Mr. Rajan Kumar',
    },
    Sales: {
      name: 'Erhan Javarkar',
    },
    unit: {
      status: 'On Hold',
      allotmentDate: 1663747450294,
      number: 101,
    },
  });
  const [leadArray, setLeadArray] = useState([]);
  //customise dropdown
  const [showDropDown, setShowDropDown] = useState(false);
  const [listOfDropDown, setListOfDropDown] = useState([
    // "Type of Lead",
    { label: 'None', select: true },
    { label: 'Date', select: false },
    { label: 'CP', select: false },
    { label: 'SM', select: false },
    { label: 'Project', select: false },
    { label: 'Lead Quality', select: false },
    { label: 'Status', select: false },
    { label: 'Lead Type', select: false }
  ]);
  const [helperText, setHelperText] = useState({
    startDate: '',
    endDate: '',
  });
  const [addLeadModal, setAddLeadModal] = useState(false);
  //Filters
  const [selectDates, setSelectDates] = useState([
    { label: 'StartDate', value: '' },
    { label: 'EndDate', value: '' },
  ]);
  

  const [showDates, setShowDates] = useState(false);
  const [showAllCpDropDown, setShowAllCpDropDown] = useState(false);
  const [allCpDropDown, setAllCpDropDown] = useState([]);
  const [showAllSalesDropDown, setShowAllSalesDropDown] = useState(false);
  const [allSalesDropDown, setAllSalesDropDown] = useState([]);
  const [showAllProjectsDropDown, setShowAllProjectsDropDown] = useState(false);
  const [allProjectsDropDown, setAllProjectsDropDown] = useState([]);
  const [showAllLeadQualityDropDown, setShowAllLeadQualityDropDown] = useState(false);
  const [allLeadQualityDropDown, setAllLeadQualityDropDown] = useState([
    {
      label: 'WARM',
      value: false,
    },
    {
      label: 'HOT',
      value: false,
    },
    {
      label: 'COLD',
      value: false,
    },
    {
      label: 'LOST',
      value: false,
    },
  ]);
  const [showLeadTypeDropDown, setShowLeadTypeDropdown] = useState(false);
  const [leadTypeDropDown, setLeadTypeDropDown] = useState([
    {
      label: 'Direct',
      value: false,
    },
    {
      label: 'CP',
      value: false,
    },
    {
      label: 'R&L',
      value: false,
    }
  ]);
  const [showAllStatusDropDown, setShowAllStatusDropDown] = useState(false);
  const [allStatusDropDown, setAllStatusDropDown] = useState([
    { label: 'Unclaimed', value: false },
    { label: 'Claimed', value: false },
    { label: 'Site Visit Scheduled', values: false },
    { label: 'Site Visit Done', values: false },
    { label: 'Token Payment Pending', value: false },
    { label: 'Token Payment Complete', values: false },
    { label: 'Token Partial Payment Done', values: false },
    { label: 'Checkpoint One Cleared', values: false },
    { label: 'Checkpoint Two Cleared', values: false },
    { label: 'Token Refund Requested', values: false },
    { label: 'Token Refunded', values: false },
    { label: 'Token Refund Request Rejected', values: false },
    { label: 'Allotment Payment Complete', value: false },
    { label: 'Allotment Payment Pending', values: false },
    { label: 'Allotment Partial Payment Done', values: false },
    { label: 'Allotment Refunded', values: false },
    // { label: 'PreSelect Payment Pending', values: false },
    { label: 'Preselect Not Confirmed', values: false },
    { label: 'PreSelect Unit On Hold', values: false },
    // { label: 'Preselect payment not done', values: false },
    { label: 'PreSelect Partial Payment Done', values: false },
    // { label: "PreSelect Confirmation Pending", values: false },
    // { label: 'PreSelect Price Confirmation Pending', values: false },
    { label: 'PreSelect Price Confirmation Pending', values: false },
    { label: 'Cancellation Confirmation Pending', values: false },
    { label: 'Cancellation Pending', values: false },
    { label: 'Cancellation Not Done', values: false },
    { label: 'Cancellation Done', values: false },
    // { label: "Change Unit Confirmation Pending", values: false },
    // { label: "Change Unit Requested", values: false },
    // { label: "Change Unit Confirmation Pending", values: false },
    // { label: "Change Unit Confirmation Rejected", values: false },
    // { label: "Change Unit Confirmed", values: false },
    // { label: "Change Unit Rejected", values: false },
    { label: 'Unit On Hold', values: false },
    { label: 'Closed', values: false },
  ]);
  const [selectedListDropDown, setSelectedListDropDown] = useState([]);
  const [pageNumber, setPageNumber] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [loadingStatus, setLoadingStatus] = useState(0);
  const [noLeadsPresent, setNoLeadsPresent] = useState(null);
  const [leadsCount, setLeadsCount] = useState(0);
  const [search, setSearch] = useState('');

  const [DropDownCpSearch, setDropDownCpSearch] = useState('');
  const [DropdownSalesSearch, setDropDownSalesSearch] = useState('');
  const [DropdownProjectSearch, setDropDownProjectSearch] = useState('');
  //Selected Values
  const [selectedDates, setSelectedDate] = useState(null);
  const [selectedCP, setSelectedCP] = useState([]);
  const [selectedSales, setSelectedSales] = useState([]);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [selectedLeadQuality, setSelectedLeadQuality] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState([]);
  const [selectedLeadType, setSelectedLeadType] = useState([]);
  const [reAssignLeadModal, setReAssignLeadModal] = useState(false);
  const [assignTitle, setAssignTitle] = useState("Claim leads");
  const [selectedLeads, setSelectedLeads] = useState([]);
  const [selectMultipleLeads, setSelectMultipleLeads] = useState(false);
  const dropDownList = ["Claim Leads", "Assign Lead", "Reassign Lead"];
  const [leadsAction, setLeadsAction] = useState(["No Action Available"]);
  const [params, setParams] = useSearchParams();
  const tabList = tabs.map((each, index) => {
    return (
      <Tab
      
        label={each}
        key={index}
        value={each}
        sx={[
          {
            fontFamily: 'Inter-Medium !important',
            fontStyle: 'normal !important',
            fontWeight: '500 !important',
            fontSize: '1.4rem !important',
            lineHeight: '2rem !important',
            textTransform: 'none !important',
          },
        ]}
      />
    );
  });
  //on initial mount

  const dispatch = useDispatch();

  useEffect(() => {

    if (sessionStorage.getItem('LeadName')) {
      setTabValue('All');
      setSearch(sessionStorage.getItem('LeadName'))
      setSendTabValue('All');

    }

  }, [])

  useEffect(() => {
    dispatch(action.activeMenu('leads'));
    getAllCp('');
    //  let  allProject=await
    getAllProject('');
    getAllUser(''); //Sales
    setPageNumber(0);
    setLoadingStatus(0);
    setLeadArray([]);
    let tempSideMenuArray = [];
    tabs.forEach((el, index) => {
      if (
        Object.keys(loggedInUser?.roleId?.accessibleTabs?.Leads).includes(el)
      ) {
        // console.log(el);
        if (loggedInUser?.roleId?.accessibleTabs?.Leads?.[el]?.isAccessible) {
          // console.log(el);
          tempSideMenuArray.push(el);
        }
      }
    });
    // console.log(tempSideMenuArray);
    // "Lost" is a new tab with no per-role accessibleTabs entry yet. Per spec any
    // sales manager can access it, so always surface it for users who can see Leads.
    if (!tempSideMenuArray.includes('Lost')) {
      tempSideMenuArray.push('Lost');
    }
    setTab([...tempSideMenuArray]);

    if (sessionStorage.getItem('LeadName')) {
      setTabValue("All");
      setSendTabValue("All");
    } else {
    setSendTabValue(tempSideMenuArray[0]);
    setTabValue(tempSideMenuArray[0]);
}



    if (sessionStorage.getItem('LeadName')) {

      document.getElementById("input-with-icon-textfield leadSearch").value = sessionStorage.getItem('LeadName')
      debouncedFetchSearchData({ target: { value: sessionStorage.getItem('LeadName') } })
      // clear
    }


    if (params.get('Tab')) {
      // console.log("params.get('Tab')", params.get('Tab'))

      if (sessionStorage.getItem('LeadName')) {
        setSendTabValue('All');
        setTabValue("All")

      } else {
      setTabValue(params.get('Tab'));
      setSendTabValue(params.get('Tab'));
    }
}
    if (params.get('Project')) {
      if (params.get('Project') !== 'All') {
        setSelectedProjects(params.get('Project'));
        getProjectsForLeadFilter(loggedInUser?.name, loggedInUser.userId)
          .then((resp) => {
            let tempArray = allProjectsDropDown;
            tempArray = resp.map((el, index) => {
              return {
                label: el.projectName,
                value: false,
                id: el.projectId,
              };
            });
            let checkProjectSelected = tempArray.filter(
              (el) => el.label === params.get('Project')
            );
            let indexOfSelectedProject = findIndex(
              tempArray,
              ({ label }) => label === params.get('Project')
            );
            setAllProjectsDropDown((pre) => {
              pre[indexOfSelectedProject].value = true;
              return [...pre];
            });
            // !!Main Filter index for Project
            let indexOfMainList = findIndex(
              listOfDropDown,
              ({ label }) => label === 'Project'
            );
            if (checkProjectSelected.length > 0) {
              setListOfDropDown((pre) => {
                pre[indexOfMainList].select = true;
                pre[0].select = false;
                return [...pre];
              });
              selectedListDropDown.push('Project');
            } else {
              setListOfDropDown((pre) => {
                pre[indexOfMainList].select = false;
                return [...pre];
              });
              setSelectedListDropDown([
                ...selectedListDropDown.filter((value) => value !== 'Project'),
              ]);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    }

    if (params.get('kycFormFilled') === 'Yes') {
      setTabValue('Allotment');
      setSendTabValue('Allotment');
      // !!Set Filter value
      setSelectedStatus(['Allotment Payment Complete']);
      selectedListDropDown.push('Status');
      // Filter Set

      let checkStatusSelected = allStatusDropDown.filter(
        (el) => el.label === 'Allotment Payment Complete'
      );
      let findIndexOfCurrentStatus = allStatusDropDown.findIndex(
        (el) => el.label === 'Allotment Payment Complete'
      );
      setAllStatusDropDown((pre) => {
        pre[findIndexOfCurrentStatus].value = true;
        return [...pre];
      });
      let indexOfMainList = findIndex(
        listOfDropDown,
        ({ label }) => label === 'Status'
      );
      if (checkStatusSelected.length > 0) {
        setListOfDropDown((pre) => {
          pre[indexOfMainList].select = true;
          pre[0].select = false;
          return [...pre];
        });
      }
    } else if (params.get('kycFormFilled') === 'No') {
      setTabValue('Allotment');
      setSendTabValue('Allotment');
      setSelectedStatus([
        'Allotment Partial Payment Done',
        'Allotment Payment Pending',
      ]);
      selectedListDropDown.push('Status');
      // Filter Set

      let checkStatusSelected = allStatusDropDown.filter(
        (el) => el.label === 'Allotment Partial Payment Done'
      );
      let findIndexOfCurrentStatus = allStatusDropDown.findIndex(
        (el) => el.label === 'Allotment Partial Payment Done'
      );
      setAllStatusDropDown((pre) => {
        pre[findIndexOfCurrentStatus].value = true;
        return [...pre];
      });
      let indexOfMainList = findIndex(
        listOfDropDown,
        ({ label }) => label === 'Status'
      );
      if (checkStatusSelected.length > 0) {
        setListOfDropDown((pre) => {
          pre[indexOfMainList].select = true;
          pre[0].select = false;
          return [...pre];
        });
      }
    }
    if (params.get('kycFormFilled') === null) {
      let obj = [{ label: 'Unclaimed', value: false }];
      setAllStatusDropDown([...obj]);
    }
    if (loggedInUser.roleId.title !== 'Super Admin') {
      let tempArray = [
        { label: 'None', select: true },
        { label: 'Date', select: false },
        { label: 'CP', select: false },
        { label: 'SM', select: false },
        { label: 'Project', select: false },
        { label: 'Lead Quality', select: false },
        { label: 'Status', select: false },
        { label: 'Lead Type', select: false }
      ];
      setListOfDropDown([...tempArray]);
    }

    if (document.getElementById('scrollableDiv')) {
      document.getElementById('scrollableDiv').scrollTop = 0;
    }
    // getAllLeads(0,sendTabValue,search);
    getAllLeads(
      0,
      params.get('kycFormFilled')
        ? 'Allotment'
        : params.get('Tab') ?? tempSideMenuArray[0],
      // sendTabValue,
      search,
      drpDownSelectedVal,
      selectDates,
      selectedDates,
      selectedCP,
      selectedSales,
      params.get('Project') === null
        ? selectedProjects
        : params.get('Project') !== 'All'
        ? [params.get('Project')]
        : selectedProjects,
      selectedLeadQuality,
      params.get('kycFormFilled') === null
        ? selectedStatus
        : params.get('kycFormFilled') === 'Yes'
        ? ['Allotment Payment Complete']
          : ['Allotment Partial Payment Done', 'Allotment Payment Pending'],
      selectedLeadType
    );
  }, [loggedInUser]);
  // ??SnapShort
  // useEffect(() => {
  //   let updateUnitListener = supabase
  //   .from(`LeadStatus`)
  //     .on("UPDATE", (handleRecordUpdated) => {
  //       console.log(handleRecordUpdated);
  //       if (handleRecordUpdated.eventType === "UPDATE") {
  //         setPageNumber(0);
  //         getAllLeads(
  //           0,
  //           sendTabValue,
  //           search,
  //           drpDownSelectedVal,
  //           selectDates,
  //           selectedDates,
  //           selectedCP,
  //           selectedSales,
  //           selectedProjects,
  //           selectedLeadQuality,
  //           selectedStatus
  //         );
  //       }
  //     })
  //     .subscribe((status) => {
  //       console.log("status: ", status);
  //     });
  //   return () => {
  //     if (updateUnitListener) {
  //       supabase.removeSubscription(updateUnitListener);
  //       updateUnitListener = null;
  //     }
  //   };
  // }, [])

  // useEffect(() => {
  //   setPageNumber(0);
  //   setLoadingStatus(0);
  //   setLeadArray([]);
  //   if (document.getElementById("scrollableDiv")) {
  //     document.getElementById("scrollableDiv").scrollTop = 0;
  //   }
  //   let obj = [{ label: "Unclaimed", value: false }];
  //   setAllStatusDropDown([...obj]);

  //   // getAllLeads(0,sendTabValue,search);
  //   getAllLeads(
  //     0,
  //     sendTabValue,
  //     search,
  //     drpDownSelectedVal,
  //     selectDates,
  //     selectedDates,
  //     selectedCP,
  //     selectedSales,
  //     selectedProjects,
  //     selectedLeadQuality,
  //     selectedStatus
  //   );
  // }, []);
  const tabChange = (event, newValue) => {
    // console.log(newValue);
    setSelectMultipleLeads(false)
    setPageNumber(0);
    setTabValue(newValue);
    setLeadArray([]);
    setDrpDownSelectedVal('Latest First');
    document.getElementById('input-with-icon-textfield leadSearch').value = '';
    setSearch('');
    setPageNumber(0);
    if (newValue === 'Unclaimed') {
      let obj = [{ label: 'Unclaimed', value: false }];
      setAllStatusDropDown([...obj]);

      setSendTabValue('Unclaimed');
      clearFilters();
      getAllLeads(
        0,
        'Unclaimed',
        '',
        'Latest First',
        selectDates,
        null,
        [],
        [],
        [],
        [],
        [],
        []
      );
    } else if (newValue === 'Nuturing') {
      let obj = [
        { label: 'Claimed', value: false },
        { label: 'Site Visit Scheduled', values: false },
        // { label: "Site Visit Pending", values: false },
      ];
      setAllStatusDropDown([...obj]);
      setSendTabValue('Nuturing');
      clearFilters();
      getAllLeads(
        0,
        'Nuturing',
        '',
        'Latest First',
        selectDates,
        null,
        [],
        [],
        [],
        [],
        [],
        []
      );
    } else if (newValue === 'Site Visit') {
      let obj = [
        { label: 'Site Visit Done', values: false },
        // { label: "Token Payment Pending", value: false },
      ];
      setAllStatusDropDown([...obj]);
      setSendTabValue('Site Visit');
      clearFilters();
      getAllLeads(
        0,
        'Site Visit',
        '',
        'Latest First',
        selectDates,
        null,
        [],
        [],
        [],
        [],
        [],
        []
      );
    } else if (newValue === 'Token') {
      let obj = [
        { label: 'Token Payment Pending', value: false },
        { label: 'Token Payment Complete', values: false },
        { label: 'Token Partial Payment Done', values: false },
        { label: 'Checkpoint One Cleared', values: false },
        { label: 'Checkpoint Two Cleared', values: false },
        { label: 'Token Refund Requested', values: false },
        { label: 'Token Refunded', values: false },
        { label: 'Token Refund Request Rejected', values: false },
      ];
      setAllStatusDropDown([...obj]);
      setSendTabValue('Token');
      clearFilters();
      getAllLeads(
        0,
        'Token',
        '',
        'Latest First',
        selectDates,
        null,
        [],
        [],
        [],
        [],
        [],
        []
      );
    } else if (newValue === 'Allotment') {
      let obj = [
        { label: 'Allotment Payment Complete', value: false },
        { label: 'Allotment Payment Pending', values: false },
        { label: 'Allotment Partial Payment Done', values: false },
        { label: 'Allotment Refunded', values: false },
        // { label: 'PreSelect Payment Pending', values: false },
        { label: 'Preselect Not Confirmed', values: false },
        { label: 'PreSelect Unit On Hold', values: false },
        // { label: 'Preselect payment not done', values: false },
        { label: 'PreSelect Partial Payment Done', values: false },
        // { label: "PreSelect Confirmation Pending", values: false },
        // { label: 'PreSelect Price Confirmation Pending', values: false },
        { label: 'PreSelect Price Confirmation Pending', values: false },
        { label: 'Cancellation Confirmation Pending', values: false },
{ label: 'Cancellation Pending', values: false },
        { label: 'Cancellation Not Done', values: false },
        { label: 'Cancellation Done', values: false },
        // { label: "Change Unit Requested", values: false },
        // { label: "Change Unit Confirmation Pending", values: false },
        // { label: "Change Unit Confirmation Rejected", values: false },
        // { label: "Change Unit Confirmed", values: false },
        // { label: "Change Unit Rejected", values: false },
        { label: 'Unit On Hold', values: false },
        { label: 'Unit Change Requested', values: false },
      ];
      setAllStatusDropDown([...obj]);
      setSendTabValue('Allotment');
      clearFilters();
      getAllLeads(
        0,
        'Allotment',
        '',
        'Latest First',
        selectDates,
        null,
        [],
        [],
        [],
        [],
        [],
        []
      );
    } else if (newValue === 'Agreement Done') {
      setSendTabValue('Agreement Done');
      clearFilters();
      let obj = [{ label: 'Agreement Done', values: false }];
      setAllStatusDropDown([...obj]);
      getAllLeads(
        0,
        'Agreement Done',
        '',
        'Latest First',
        selectDates,
        null,
        [],
        [],
        [],
        [],
        [],
        []
      );
    }
    if (newValue === 'All') {
      setSendTabValue('All');
      clearFilters();
      let obj = [
        { label: 'Unclaimed', value: false },
        { label: 'Claimed', value: false },
        { label: 'Site Visit Scheduled', values: false },
        { label: 'Site Visit Done', values: false },
        { label: 'Token Payment Pending', value: false },
        { label: 'Token Payment Complete', values: false },
        { label: 'Token Partial Payment Done', values: false },
        { label: 'Checkpoint One Cleared', values: false },
        { label: 'Checkpoint Two Cleared', values: false },
        { label: 'Token Refund Requested', values: false },
        { label: 'Token Refunded', values: false },
        { label: 'Token Refund Request Rejected', values: false },
        { label: 'Allotment Payment Complete', value: false },
        { label: 'Allotment Payment Pending', values: false },
        { label: 'Allotment Partial Payment Done', values: false },
        { label: 'Allotment Refunded', values: false },
        { label: 'PreSelect Payment Pending', values: false },
        // { label: 'PreSelect Payment Pending', values: false },
        { label: 'Preselect Not Confirmed', values: false },
        { label: 'PreSelect Unit On Hold', values: false },
        // { label: 'Preselect payment not done', values: false },
        { label: 'PreSelect Partial Payment Done', values: false },
        // { label: "PreSelect Confirmation Pending", values: false },
        // { label: 'PreSelect Price Confirmation Pending', values: false },
        { label: 'PreSelect Price Confirmation Pending', values: false },
        { label: 'Cancellation Confirmation Pending', values: false },
        { label: 'Cancellation Pending', values: false },
        { label: 'Cancellation Not Done', values: false },
        { label: 'Cancellation Done', values: false },
        { label: 'Unit Change Requested', values: false },
        // { label: "Change Unit Confirmation Pending", values: false },
        // { label: "Change Unit Requested", values: false },
        // { label: "Change Unit Confirmation Pending", values: false },
        // { label: "Change Unit Confirmation Rejected", values: false },
        // { label: "Change Unit Confirmed", values: false },
        // { label: "Change Unit Rejected", values: false },
        { label: 'Unit On Hold', values: false },
        { label: 'Closed', values: false },
        { label: 'Agreement Done', values: false },
      ];
      setAllStatusDropDown([...obj]);
      getAllLeads(
        0,
        'All',
        '',
        'Latest First',
        selectDates,
        null,
        [],
        [],
        [],
        [],
        [],
        []
      );
    }
    if (newValue === 'Lost') {
      // Lost is served by <LostLeads /> via its own endpoint; just set the tab
      // and reset filters. The filter/sort/search controls feed it through props.
      setSendTabValue('Lost');
      clearFilters();
    }
  };
  function getAllCp(search) {
    getAllCpForLaunch(search)
      .then((resp) => {
                let tempArray = allCpDropDown;
        tempArray = resp.data.map((el, index) => {
          return {
            label: el.billingName,
            value: false,
            id: el.cpId,
          };
        });
        const sortedCp = orderBy(
          tempArray,
          [(cp) => cp.label.toLowerCase()],
          ['asc']
        );
        setAllCpDropDown(sortedCp);
        // console.log("cp" , tempArray)
      })
      .catch((err) => {
        console.log(err);
      });
  }

  function getAllProject(search) {
    getProjectsForLeadFilter(loggedInUser?.name, loggedInUser.userId, search)
      .then((resp) => {
        let tempArray = allProjectsDropDown;
        tempArray = resp.map((el, index) => {
          return {
            label: el.projectName,
            value: false,
            id: el.projectId,
          };
        });
        const sortedProjects = orderBy(
          tempArray,
          [(project) => project.label.toLowerCase()],
          ['asc']
        );
        setAllProjectsDropDown(sortedProjects);
        // console.log("okokok",tempArray)
      })
      .catch((err) => {
        console.log(err);
      });
  }
  // async function getAllProject() {
  //   return new Promise((resolve, reject) => {
  //   getProjects(loggedInUser?.name,loggedInUser.userId)
  //     .then((resp) => {
  //       let tempArray = allProjectsDropDown;
  //       tempArray = resp.map((el, index) => {
  //         return {
  //           label: el.projectName,
  //           value: false,
  //           id: el.projectId,
  //         };
  //       });
  //       setAllProjectsDropDown(tempArray);
  //       console.log(tempArray)
  //       resolve(tempArray);
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     });
  //   });
  // }
  function getAllUser(search) {
    if (loggedInUser.roleId.title !== 'Super Admin') {
      const teamIds = JSON.parse(localStorage.getItem('teamIds'));
      // console.log("teamIds", typeof (teamIds));

      if (Array.isArray(teamIds) && teamIds.length > 0) {
        getUsers(search, loggedInUser, teamIds).then(resp => {
          // console.log("resp", resp)
          let tempArray = allSalesDropDown;
          tempArray = resp.data.map((el, index) => {
            return {
              label: el.name,
              value: false,
              id: el.userId,
            };
          });
          const sortedArray = orderBy(
            tempArray,
            [(user) => user.label.toLowerCase()],
            ['asc']
          );
          setAllSalesDropDown(sortedArray);
        }).catch((err) => {
          console.log(err);
        })
      }
    } else {
      getUsers(search, loggedInUser)
      .then((resp) => {
        // console.log("resp---->" , resp)
        let tempArray = allSalesDropDown;
        tempArray = resp.data.map((el, index) => {
          return {
            label: el.name,
            value: false,
            id: el.userId,
          };
        });
        const sortedArray = orderBy(
          tempArray,
          [(user) => user.label.toLowerCase()],
          ['asc']
        );
        setAllSalesDropDown(sortedArray);
      })
      .catch((err) => {
        console.log(err);
      });
    }
  }
  function getAllLeads(
    _pageNumber,
    sendTabValue,
    search,
    _drpDownSelectedVal,
    selectDates,
    selectedDates,
    selectedCP,
    selectedSales,
    selectedProjects,
    selectedLeadQuality,
    selectedStatus,
    selectedLeadType
  ) {
    // The Lost tab is served by <LostLeads /> (its own contact-masked endpoint),
    // not the leads RPC. The filter/sort controls feed it via props, so skip the
    // RPC here entirely on Lost.
    if (sendTabValue === 'Lost') return;
    Network.getStatus().then((status) => {
      if (status.connected) {
        presentLoader();
        getLeadsFromRpc(
          _pageNumber * pageSize,
          _pageNumber * pageSize + pageSize - 1,
          sendTabValue,
          search,
          _drpDownSelectedVal,
          selectDates,
          selectedDates,
          selectedCP,
          selectedSales,
          selectedProjects,
          selectedLeadQuality,
          selectedStatus,
          loggedInUser.userId,
          loggedInUser.roleId.title,
          loggedInUser,
          selectedLeadType
        )
          .then(async (resp) => {
            dismissLoader();
            // console.log('Leads', resp);
            setLeadsCount(resp.count);
            if (resp.count > 0) {
              setNoLeadsPresent(true);
            } else {
              setNoLeadsPresent(false);
            }
            if (resp.count > resp.data.length) {
              setLoadingStatus(0);
              setPageNumber(1);
            } else {
              setLoadingStatus(-1);
              setPageNumber(0);
            }
            resp.data = resp.data.map((el, index) => ({
              ...el,
              person: {
                name: el?.leadname,
                personId: el?.personid,
              },
              id:
                'VJ' +
                el?.leaddisplayid?.replace(
                  el?.leaddisplayid?.substring(8, 12),
                  '-' + el?.leaddisplayid?.substring(8, 12)
                ),
              // !!Change on 17/05/23
              // createdAt: el?.statuschangeddate,
              createdAt: el?.created_at,
              last_updated_at: el?.statuschangeddate,
              type: el?.leadtype,
              status: el?.leadstatus,
              leadId: el?.id,
              leadStatus: el?.leadresponse ? el?.leadresponse : 'WARM',
              FOS: {
                name: el?.fosname ? el?.fosname : '-',
                fosId: el?.fosid ? el?.fosid : '-',
              },
              CP: {
                name: el?.cpname ? el?.cpname : '-',
                cpId: el?.cpid ? el?.cpid : '-',
              },
              Sales: {
                name: el?.salesname ? el?.salesname : '-', //Sie Visit
                userId: el?.salesid ? el?.salesid : '-',
                email: el?.useremail,
                contactNumber: el?.usercontactnumber,
              },
              unit: {
                status: '',
                allotmentDate: '',
                number: '',
              },
              project: {
                unitType: el?.unittype,
                name: el?.projectname,
              },
              leadDetails: {
                contactNumber: el?.leadcontactnumber,
                leadEmail: el?.leademail,
              },
              isverified: el?.isverified ?? false,
              regeneratedFromLeadId: el?.regeneratedfromleadid ?? null,
              isSelected: false
            }));
            resp.data = await overrideStaleApprovalStatuses(resp.data);

            //             if(sessionStorage.getItem("LeadId")){
            // // console.log("%%", resp.data[0].leadId)
            // const filterDataById =  resp.data.filter(el=> console.log("**",el === sessionStorage.getItem("LeadId")))
            // console.log("%%", [...filterDataById]) 
            // setLeadArray([...filterDataById]);

            //             }else{
            //               setLeadArray([...resp.data]);
            //             }

            setLeadArray([...resp.data]);
          })
          .catch((err) => {
            dismissLoader();
            //  errorTost(err.message);
          });
      } else {
        offlineToast();
      }
    });
  }
  function getMoreData() {
    // Lost tab paginates inside <LostLeads />, not via this RPC infinite-scroll.
    if (sendTabValue === 'Lost') return;
    if (loadingStatus !== 0) return;
    setLoadingStatus(1);
    Network.getStatus().then((status) => {
      if (status.connected) {
        presentLoader();
        getLeadsFromRpc(
          pageNumber * pageSize,
          pageNumber * pageSize + pageSize - 1,
          sendTabValue,
          search,
          drpDownSelectedVal,
          selectDates,
          selectedDates,
          selectedCP,
          selectedSales,
          selectedProjects,
          selectedLeadQuality,
          selectedStatus,
          loggedInUser.userId,
          loggedInUser.roleId.title,
          loggedInUser,
          selectedLeadType
        )
          .then(async (resp) => {
            dismissLoader();
            if (resp.count > resp.data.length + leadArray.length) {
              setLoadingStatus(0);
              setPageNumber(pageNumber + 1);
            } else {
              setLoadingStatus(-1);
              setPageNumber(0);
            }
            if (resp.count > 0) {
              setNoLeadsPresent(true);
            } else {
              setNoLeadsPresent(false);
            }
            resp.data = resp.data.map((el, index) => ({
              ...el,
              person: {
                name: el?.leadname,
                personId: el?.personid,
              },
              id:
                'VJ' +
                el?.leaddisplayid?.replace(
                  el?.leaddisplayid?.substring(8, 12),
                  '-' + el?.leaddisplayid?.substring(8, 12)
                ),
              // createdAt: el?.statuschangeddate,
              createdAt: el?.created_at,
              last_updated_at: el?.statuschangeddate,
              type: el?.leadtype,
              status: el?.leadstatus,
              leadId: el?.id,
              leadStatus: el?.leadresponse ? el?.leadresponse : 'WARM',
              FOS: {
                name: el?.fosname ? el?.fosname : '-',
                fosId: el?.fosid ? el?.fosid : '-',
              },
              CP: {
                name: el?.cpname ? el?.cpname : '-',
                cpId: el?.cpid ? el?.cpid : '-',
              },
              Sales: {
                name: el?.salesname ? el?.salesname : '-', //Sie Visit
                userId: el?.salesid ? el?.salesid : '-',
                email: el?.useremail,
                contactNumber: el?.usercontactnumber,
              },
              unit: {
                status: '',
                allotmentDate: '',
                number: '',
              },
              project: {
                unitType: el?.unittype,
                name: el?.projectname,
              },
              leadDetails: {
                contactNumber: el?.leadcontactnumber,
                leadEmail: el?.leademail,
              },
              isverified: el?.isverified ?? false,
              regeneratedFromLeadId: el?.regeneratedfromleadid ?? null,
              isSelected: false
            }));
            resp.data = await overrideStaleApprovalStatuses(resp.data);
            setLeadArray((pre) => [...pre, ...resp.data]);
          })
          .catch((err) => {
            dismissLoader();
            errorTost(err.message);
          });
      } else {
        offlineToast();
      }
    });
    setLoadingStatus(0);
  }
  function claimLead(data) {
    Network.getStatus().then(async (status) => {
      if (status.connected) {
        let teamLeadRes = null;
        // !!Finding Team Lead for dashboard purpose and updating it whenever SM changes
        // !!Commmented this  due to changes come on 18/4/23
        // if (
        //   (loggedInUser?.isTeamLead === false ||
        //     loggedInUser?.isTeamLead === null) &&
        //   loggedInUser?.parentId !== null
        // ) {
        //   teamLeadRes = await findTeamLead(loggedInUser?.parentId?.userId);
        //   console.log({ teamLeadRes });
        // } else if(loggedInUser?.isTeamLead){
        //   teamLeadRes = loggedInUser?.userId;
        // }else{
        //   // !!SuperAdmin
        //   teamLeadRes=null;
        // }
        updateLeadForClaim(
          data.leadId,
          loggedInUser.userId,
          loggedInUser?.parentId?.userId
        )
          .then((resp) => {
            updateLeadStatus(data.leadId)
              .then(async (resp) => {
                let obj = {
                  cpId: data.cpid,
                  fosId: data.fosid,
                  userId: loggedInUser.userId,
                  leadId: data.leadId,
                  leadStatus: resp[0].status,
                  message: `Lead claimed by ${loggedInUser.name}(${loggedInUser.roleId.title})`,
                };
                //Send whatsapp message
                let whatsappToast = "";
                await sendWhatsappMessageOnLeadClaimed(data?.leadname,
                  data?.leadcontactnumber,
                  data?.project?.name,
                  loggedInUser?.name,
                ).then((res) => {
                  console.log("Whatsapp response", res);
                  whatsappToast = "Whatsapp message sent successfully."
                }).catch((err) => {
                  console.log("Whatsapp error", err);
                  whatsappToast = "Error while sending whatsapp message."
                })
                addLeadLogs(obj)
                  .then((leadLog) => {
                    console.log(leadLog);
                  })
                  .catch((err) => {
                    console.log('leadlog', err);
                  });
                document.getElementById(
                  'input-with-icon-textfield leadSearch'
                ).value = '';
                setDrpDownSelectedVal('Latest First');
                // clearFilters();
                setLeadArray([]);
                setPageNumber(0);
                setLoadingStatus(0);

                setLeadArray([]);
                getAllLeads(
                  0,
                  sendTabValue,
                  '',
                  'Latest First',
                  selectDates,
                  selectedDates,
                  selectedCP,
                  selectedSales,
                  selectedProjects,
                  selectedLeadQuality,
                  selectedStatus,
                  selectedLeadType
                );
                successTost(`${data.leadname} claimed successfully. ${whatsappToast}`);
              })
              .catch((err) => {
                console.log(err);
              });
          })
          .catch((err) => {
            errorTost(err.message);
          });
      } else {
        offlineToast();
      }
    });
  }
  async function findTeamLead(userId) {
    return new Promise((resolve, reject) => {
      getUsersForTeamLead(userId).then((userRes) => {
        if (userRes[0].parentId !== null) {
          if (userRes[0].isTeamLead) {
            resolve(userRes[0].userId);
          } else if (!userRes[0].isTeamLead) {
            findTeamLead(userRes[0]?.parentId);
          } else {
            resolve(null);
          }
        } else {
          resolve(null);
        }
      });
    });
  }
  function leadAdded(respValue) {
    setTimeout(() => {
      if (respValue) {
        document.getElementById('input-with-icon-textfield leadSearch').value =
          '';
        clearFilters();
        setLeadArray([]);
        setPageNumber(0);
        setLoadingStatus(0);
        setSendTabValue('Nuturing');
        setTabValue('Nuturing');
        getAllLeads(
          0,
          'Nuturing',
          '',
          'Latest First',
          selectDates,
          null,
          [],
          [],
          [],
          [],
          [],
          []
        );
      }
    }, 300);
  }

  function funReturnRes(value) {
    setTimeout(() => {
      if (value) {
        document.getElementById('input-with-icon-textfield leadSearch').value =
          '';
        clearFilters();
        setLeadArray([]);
        setPageNumber(0);
        setLoadingStatus(0);
        setLeadArray([]);
        getAllLeads(
          0,
          sendTabValue,
          '',
          'Latest First',
          selectDates,
          null,
          [],
          [],
          [],
          [],
          [],
          []
        );
      }
    }, 300);
  }
  function clearFilters() {
    setLeadArray([]);
    setSelectedListDropDown([]);
    setListOfDropDown((pre) => {
      pre = pre.map((m) => ({
        ...m,
        select: false,
      }));
      pre[0].select = true;
      return [...pre];
    });
    setAllCpDropDown((pre) => {
      pre = pre.map((m) => ({
        ...m,
        value: false,
      }));
      return [...pre];
    });
    setAllProjectsDropDown((pre) => {
      pre = pre.map((m) => ({
        ...m,
        value: false,
      }));
      return [...pre];
    });
    setAllSalesDropDown((pre) => {
      pre = pre.map((m) => ({
        ...m,
        value: false,
      }));
      return [...pre];
    });
    setAllLeadQualityDropDown((pre) => {
      pre = pre.map((m) => ({
        ...m,
        value: false,
      }));
      return [...pre];
    });
    setLeadTypeDropDown((pre) => {
      pre = pre.map((m) => ({
        ...m,
        value: false,
      }));
      return [...pre];
    })
    setAllStatusDropDown((pre) => {
      pre = pre.map((m) => ({
        ...m,
        value: false,
      }));
      return [...pre];
    });
    setSelectedDate(null);
    setShowDropDown(false);
    setShowAllCpDropDown(false);
    setShowAllSalesDropDown(false);
    setShowAllProjectsDropDown(false);
    setShowAllLeadQualityDropDown(false);
    setShowLeadTypeDropdown(false);
    setShowAllStatusDropDown(false);
    setShowDates(false);
    setSelectedCP([]);
    setSelectedLeadQuality([]);
    setSelectedLeadType([]);
    setSelectedProjects([]);
    setSelectedSales([]);
    setSelectedStatus([]);
    setDropDownCpSearch('');
    setDropDownProjectSearch('');
    setDropDownSalesSearch('');
    getAllCp('');
    getAllUser('');
    getAllProject('');
    setSelectDates((pre) => {
      pre[0].value = '';
      pre[1].value = '';
      return { ...pre };
    });
  }
  const debouncedFetchSearchData = debounce((e) => {
    // console.log({val : e.target.value})
    setLeadArray([]);
    setSearch(e.target.value);
    // setSearch(sessionStorage.getItem('LeadName') || e.target.value)
    setPageNumber(0);
    // The Lost tab renders <LostLeads /> which filters on the `search` value
    // client-side; it does not use getAllLeads (different REST endpoint), so
    // skip the RPC call here to avoid a wasteful/irrelevant fetch.
    if (tabValue === 'Lost') {
      return;
    }
    // console.log({
    //   sendTabValue,
    //   search,
    //   drpDownSelectedVal,
    //   selectDates,
    //   selectedDates,
    //   selectedCP,
    //   selectedSales,
    //   selectedProjects,
    //   selectedLeadQuality,
    //   selectedStatus
    // })
    getAllLeads(
      0,
      sendTabValue,
      e.target.value,
      // search,
      drpDownSelectedVal,
      selectDates,
      selectedDates,
      selectedCP,
      selectedSales,
      selectedProjects,
      selectedLeadQuality,
      selectedStatus,
      selectedLeadType
    );
  }, 800);
 
// useEffect(()=>{
//   search &&debouncedFetchSearchData()
  
// },[search])
  const debouncedFetchDropDownSearch1 = debounce((e) => {
    if (showAllCpDropDown) {
      setDropDownCpSearch(e.target.value);
      getAllCp(e.target.value);
    }
  }, 800);

  const debouncedFetchDropDownSearch2 = debounce((e) => {
    if (showAllSalesDropDown) {
      setDropDownSalesSearch(e.target.value);
      getAllUser(e.target.value);
    }
  }, 800);

  const debouncedFetchDropDownSearch3 = debounce((e) => {
    if (showAllProjectsDropDown) {
      setDropDownProjectSearch(e.target.value);
      getAllProject(e.target.value);
    }
  }, 800);
  function handleSelectedLeads(e) {
    const selectedLeadData = leadArray.filter((lead) => lead.isSelected);
    if (selectedLeadData.length > 0) {
      if (e === "Reassign Lead") {
        setSelectedLeads(selectedLeadData)
        setReAssignLeadModal(true);
        setAssignTitle("Reassign Lead");
      } else if (e === "Assign Lead") {
        setSelectedLeads(selectedLeadData)
        setReAssignLeadModal(true);
        setAssignTitle("Assign Lead");
      } else {
        setSelectedLeads(selectedLeadData)
        claimMultipleLeads(selectedLeadData);
      }
    } else {
      errorTost("Please select Lead");
    }
  }
  function returnRes(value) {
    if (value) {
      setReAssignLeadModal(false);
      document.getElementById(
        'input-with-icon-textfield leadSearch'
      ).value = '';
      setDrpDownSelectedVal('Latest First');
      clearFilters();
      setLeadArray([]);
      setPageNumber(0);
      setLoadingStatus(0);

      setLeadArray([]);
      getAllLeads(
        0,
        sendTabValue,
        '',
        'Latest First',
        selectDates,
        null,
        [],
        [],
        [],
        [],
        [],
        []
      );
    }
  }

  function claimMultipleLeads(data) {
    Network.getStatus().then(async (status) => {
      if (status.connected) {
        const leadIds = data.map(lead => lead.leadId);
        updateMultipleLeadForClaim(
          leadIds,
          loggedInUser.userId,
          loggedInUser?.parentId?.userId
        )
          .then((resp) => {
            updateMultipleLeadStatus(leadIds)
              .then(async (resp) => {
                const leadsArray = data.map(lead => ({
                  cpId: lead.cpId,
                  fosId: lead.fosId,
                  userId: loggedInUser.userId,
                  leadId: lead.leadId,
                  leadStatus: resp[0].status,
                  message: `Lead claimed by ${loggedInUser.name}(${loggedInUser.roleId.title})`,
                }));

                //Send whatsapp message
                let whatsappToast = ""; //@todo for muiltiple leads
                // await sendWhatsappMessageOnLeadClaimed(data?.leadname,
                //   data?.leadcontactnumber,
                //   data?.project?.name,
                //   loggedInUser?.name,
                // ).then((res) => {
                //   console.log("Whatsapp response", res);
                //   whatsappToast = "Whatsapp message sent successfully."
                // }).catch((err) => {
                //   console.log("Whatsapp error", err);
                //   whatsappToast = "Error while sending whatsapp message."
                // })
                addMultipleLeadLogs(leadsArray)
                  .then((leadLog) => {
                    console.log(leadLog);
                  })
                  .catch((err) => {
                    console.log('leadlog', err);
                  });
                document.getElementById(
                  'input-with-icon-textfield leadSearch'
                ).value = '';
                setDrpDownSelectedVal('Latest First');
                clearFilters();
                setLeadArray([]);
                setPageNumber(0);
                setLoadingStatus(0);

                setLeadArray([]);
                getAllLeads(
                  0,
                  sendTabValue,
                  '',
                  'Latest First',
                  selectDates,
                  null,
                  [],
                  [],
                  [],
                  [],
                  [],
                  []
                );
                successTost(`Leads claimed successfully. ${whatsappToast}`);
              })
              .catch((err) => {
                console.log(err);
              });
          })
          .catch((err) => {
            errorTost(err.message);
          });
      } else {
        offlineToast();
      }
    });
  }

  return (
    // onClick={(e)=>{e.stopPropagation();setShowDropDown(false);}}
    <div className='pageWrapper'>
      <div className={cssClasses.wrapperAddLeads}>
        <div className={cssClasses.title}>Leads</div>
        {loggedInUser?.roleId?.accessibleTabs?.Leads?.['Add Leads']
          ?.isAccessible && (
          <div>
            <Button
              style={{
                color: '#fff',
                backgroundColor: '#1570EF',
                fontSize: '1.4rem',
                lineHeight: '2rem',
                fontFamily: 'Roboto-Regular',
              }}
              btnName={'Add Leads'}
              clicked={() => {
                setAddLeadModal(true);
                // console.log("clicked");
                // navigate("/home/Sustenance/ConfigureEvent/Inventory");
                // navigate("/home/Event/EventConfig/5435/Launch");
              }}
              btnIcon={<PlusIcon />}
              iconPosition={'left'}
            />
          </div>
        )}
      </div>
      <Tabs

        value={tabValue}
        onChange={tabChange}
        variant='scrollable'
        scrollButtons='auto'
        aria-label='scrollable auto tabs example'
        sx={[
          {
            borderBottom: '1px solid #EAECF0 !important',
          },
        ]}
      >
        {tabList}
      </Tabs>
      <div className={cssClasses.wrapperFilters}>
        {/* Filter by / Sort by show on every tab incl. Lost. On Lost they feed
            <LostLeads /> via props (its own endpoint) rather than the leads RPC.
            The RPC-based lead count is hidden on Lost (LostLeads shows its own). */}
        <div className={cssClasses.containerFilterSortBy}>
          {tabValue !== 'Lost' && (
            <div className={cssClasses.leadsCount}>{leadsCount} Leads </div>
          )}
          <div className={cssClasses.wrapperFilter}>
            <div className={cssClasses.filterTitle}>Filter by</div>
            <div className={cssClasses.wrapperDropDown}>
              <div
                className={cssClasses.wrapperCustomiseDropDown}
                onClick={(e) => {
                  e.stopPropagation();
                  setShowDropDown(!showDropDown);
                }}
              >
                <div className={cssClasses.dropDownLabel}>
                  <span className={cssClasses.dropDownLabelValue}>
                    {selectedListDropDown.join()}
                  </span>
                  {selectedListDropDown.length === 0 && (
                    <span className={cssClasses.dropDownLabelValue}>None</span>
                  )}
                </div>
                {showDropDown && (
                  <KeyboardArrowUpIcon className={cssClasses.dropDownIcon} />
                )}
                {showDropDown === false && (
                  <KeyboardArrowDownIcon className={cssClasses.dropDownIcon} />
                )}
              </div>
              {showDropDown && (
                <ClickAwayListener
                  onClickAway={() => {
                    setShowDropDown(false);
                  }}
                >
                  <div className={cssClasses.containerCustomiseDropDown}>
                    <div className={cssClasses.wrapperSelectAndCheckbox}>
                      <div className={cssClasses.wrapperEachSelect}>
                        {listOfDropDown.map((each, index) => {
                          return (
                            <div
                              className={
                                each.select
                                  ? cssClasses.selectedVal
                                  : cssClasses.containerEachSelect
                              }
                            >
                              <div
                                className={cssClasses.eachSelect}
                                onClick={() => {
                                  setListOfDropDown((pre) => {
                                    pre = pre.map((m) => ({
                                      ...m,
                                      select: false,
                                    }));
                                    // pre[index].select = true;
                                    return [...pre];
                                  });
                                  if (selectedDates != null) {
                                    let indexOfMainList = findIndex(
                                      listOfDropDown,
                                      ({ label }) => label === 'Date'
                                    );
                                    setListOfDropDown((pre) => {
                                      pre[indexOfMainList].select = true;
                                      return [...pre];
                                    });
                                  }
                                  allCpDropDown.forEach((el) => {
                                    if (el.value) {
                                      let indexOfMainList = findIndex(
                                        listOfDropDown,
                                        ({ label }) => label === 'CP'
                                      );
                                      setListOfDropDown((pre) => {
                                        pre[indexOfMainList].select = true;
                                        return [...pre];
                                      });
                                    }
                                  });
                                  allSalesDropDown.forEach((el) => {
                                    if (el.value) {
                                      setListOfDropDown((pre) => {
                                        let indexOfMainList = findIndex(
                                          listOfDropDown,
                                          ({ label }) => label === 'SM'
                                        );
                                        pre[indexOfMainList].select = true;
                                        return [...pre];
                                      });
                                    }
                                  });
                                  allProjectsDropDown.forEach((el) => {
                                    if (el.value) {
                                      setListOfDropDown((pre) => {
                                        let indexOfMainList = findIndex(
                                          listOfDropDown,
                                          ({ label }) => label === 'Project'
                                        );
                                        pre[indexOfMainList].select = true;
                                        return [...pre];
                                      });
                                    }
                                  });
                                  allLeadQualityDropDown.forEach((el) => {
                                    if (el.value) {
                                      let indexOfMainList = findIndex(
                                        listOfDropDown,
                                        ({ label }) => label === 'Lead Quality'
                                      );
                                      setListOfDropDown((pre) => {
                                        pre[indexOfMainList].select = true;
                                        return [...pre];
                                      });
                                    }
                                  });
                                  leadTypeDropDown.forEach((el) => {
                                    if (el.value) {
                                      let indexOfMainList = findIndex(
                                        listOfDropDown,
                                        ({ label }) => label === 'Lead Type'
                                      );
                                      setListOfDropDown((pre) => {
                                        pre[indexOfMainList].select = true;
                                        return [...pre];
                                      });
                                    }
                                  })
                                  allStatusDropDown.forEach((el) => {
                                    if (el.value) {
                                      let indexOfMainList = findIndex(
                                        listOfDropDown,
                                        ({ label }) => label === 'Status'
                                      );
                                      setListOfDropDown((pre) => {
                                        pre[indexOfMainList].select = true;
                                        return [...pre];
                                      });
                                    }
                                  });
                                  if (each.label === 'None') {
                                    setSelectedListDropDown([]);
                                    setSelectedCP([]);
                                    setSelectedLeadQuality([]);
                                    selectedLeadType([])
                                    setSelectedSales([]);
                                    setSelectedProjects([]);
                                    setSelectedStatus([]);
                                    setSelectedDate(null);
                                    setSelectDates((pre) => {
                                      pre[0].value = '';
                                      pre[1].value = '';
                                      return { ...pre };
                                    });

                                    setListOfDropDown((pre) => {
                                      pre = pre.map((m) => ({
                                        ...m,
                                        select: false,
                                      }));
                                      pre[0].select = true;
                                      return [...pre];
                                    });
                                    if (
                                      selectDates.startDate === '' ||
                                      selectDates.endDate === ''
                                    ) {
                                      setListOfDropDown((pre) => {
                                        pre[1].select = false;
                                        return [...pre];
                                      });
                                    }
                                    allCpDropDown.forEach((el) => {
                                      el.value = false;
                                    });
                                    allSalesDropDown.forEach((el) => {
                                      el.value = false;
                                    });
                                    allProjectsDropDown.forEach((el) => {
                                      el.value = false;
                                    });
                                    allLeadQualityDropDown.forEach((el) => {
                                      el.value = false;
                                    });
                                    leadTypeDropDown.forEach((el) => {
                                      el.value = false;
                                    })
                                    allStatusDropDown.forEach((el) => {
                                      el.value = false;
                                    });
                                    setShowAllCpDropDown(false);
                                    setShowAllSalesDropDown(false);
                                    setShowAllProjectsDropDown(false);
                                    setShowAllLeadQualityDropDown(false);
                                    setShowLeadTypeDropdown(false);
                                    setShowAllStatusDropDown(false);
                                    setShowDates(false);
                                    // setSelectDates((pre) => {
                                    //   pre[0].value = "";
                                    //   pre[1].value = "";
                                    //   return { ...pre };
                                    // });
                                  } else if (each.label === 'CP') {
                                    setTimeout(() => {
                                      let _va = document.getElementById(
                                        'input-with-icon-textfield DropDownLeadCpSearch'
                                      );
                                      if (_va) {
                                        _va.value = DropDownCpSearch;
                                      }
                                    }, 100);
                                    setShowAllCpDropDown(true);
                                    setShowAllSalesDropDown(false);
                                    setShowAllProjectsDropDown(false);
                                    setShowAllLeadQualityDropDown(false);
                                    setShowLeadTypeDropdown(false);
                                    setShowAllStatusDropDown(false);
                                    setShowDates(false);
                                  } else if (each.label === 'SM') {
                                    setTimeout(() => {
                                      let _va = document.getElementById(
                                        'input-with-icon-textfield DropDownLeadSalesSearch'
                                      );
                                      if (_va) {
                                        _va.value = DropdownSalesSearch;
                                      }
                                    }, 100);
                                    setShowAllSalesDropDown(true);
                                    setShowAllCpDropDown(false);
                                    setShowAllProjectsDropDown(false);
                                    setShowAllLeadQualityDropDown(false);
                                    setShowLeadTypeDropdown(false);
                                    setShowAllStatusDropDown(false);
                                    setShowDates(false);
                                  } else if (each.label === 'Project') {
                                    setTimeout(() => {
                                      let _va = document.getElementById(
                                        'input-with-icon-textfield DropDownLeadProjectsSearch'
                                      );
                                      if (_va) {
                                        _va.value = DropdownProjectSearch;
                                      }
                                    }, 100);
                                    setShowAllSalesDropDown(false);
                                    setShowAllCpDropDown(false);
                                    setShowAllProjectsDropDown(true);
                                    setShowAllLeadQualityDropDown(false);
                                    setShowLeadTypeDropdown(false);
                                    setShowAllStatusDropDown(false);
                                    setShowDates(false);
                                  } else if (each.label === 'Lead Quality') {
                                    setShowAllSalesDropDown(false);
                                    setShowAllCpDropDown(false);
                                    setShowAllProjectsDropDown(false);
                                    setShowAllLeadQualityDropDown(true);
                                    setShowLeadTypeDropdown(false);
                                    setShowAllStatusDropDown(false);
                                    setShowDates(false);
                                  } else if (each.label === 'Status') {
                                    setShowAllSalesDropDown(false);
                                    setShowAllCpDropDown(false);
                                    setShowAllProjectsDropDown(false);
                                    setShowAllLeadQualityDropDown(false);
                                    setShowLeadTypeDropdown(false);
                                    setShowAllStatusDropDown(true);
                                    setShowDates(false);
                                  } else if (each.label === 'Date') {
                                    setShowAllSalesDropDown(false);
                                    setShowAllCpDropDown(false);
                                    setShowAllProjectsDropDown(false);
                                    setShowAllLeadQualityDropDown(false);
                                    setShowLeadTypeDropdown(false);
                                    setShowAllStatusDropDown(false);
                                    setShowDates(true);
                                  } else if (each.label === "Lead Type") {
                                    setShowAllSalesDropDown(false);
                                    setShowAllCpDropDown(false);
                                    setShowAllProjectsDropDown(false);
                                    setShowAllLeadQualityDropDown(false);
                                    setShowLeadTypeDropdown(true);
                                    setShowAllStatusDropDown(false);
                                    setShowDates(false);
                                  }
                                }}
                              >
                                {each.label}
                              </div>
                              {each.select && (
                                <img
                                  src={checked}
                                  alt={'checked'}
                                  style={{ marginRight: '2rem' }}
                                />
                              )}
                            </div>
                          );
                        })}
                      </div>
                      <div className={cssClasses.wrapperCheckbox1}>
                        {showAllCpDropDown && (
                          <Box width={'100%'} mb={2}>
                            <SearchBar
                              id={'DropDownLeadCpSearch'}
                              placeholder={'Search'}
                              search={debouncedFetchDropDownSearch1}
                              width='100%'
                            />

                          </Box>
                        )}
                        {showAllSalesDropDown && (
                          <Box width={'100%'} mb={2}>
                            <SearchBar
                              id={'DropDownLeadSalesSearch'}
                              placeholder={'Search'}
                              search={debouncedFetchDropDownSearch2}
                              width='100%'
                              
                            />
                          </Box>
                        )}
                        {showAllProjectsDropDown && (
                          <Box width={'100%'} mb={2}>
                            <SearchBar
                              id={'DropDownLeadProjectsSearch'}
                              placeholder={'Search'}
                              search={debouncedFetchDropDownSearch3}
                              width='100%'
                            />
                          </Box>
                        )}
                        <div className={cssClasses.wrapperCheckbox}>
                          {showAllCpDropDown && (
                            <>
                              {allCpDropDown?.length > 0 ? (
                                allCpDropDown.map((each, index) => {
                                  return (
                                    <FormGroup>
                                      <FormControlLabel
                                        sx={[
                                          {
                                            '& .MuiTypography-root': {
                                              fontFamily:
                                                'Inter-Medium !important',
                                              fontStyle: 'normal',
                                              fontWeight: '400',
                                              fontSize: '1.6rem !important',
                                              lineHeight: '2.4rem !important',
                                              /* identical to box height, or 150% */

                                              /* Gray/900 */

                                              color: '#101828',
                                            },
                                          },
                                        ]}
                                        checked={each.value}
                                        onChange={(e) => {
                                          if (e.target.checked) {
                                            setAllCpDropDown((pre) => {
                                              pre[index].value =
                                                e.target.checked;
                                              selectedCP.push(each.id);
                                              return [...pre];
                                            });
                                          } else {
                                            setAllCpDropDown((pre) => {
                                              pre[index].value =
                                                e.target.checked;
                                              return [...pre];
                                            });
                                            setSelectedCP(
                                              selectedCP.filter(
                                                (id) => id !== each.id
                                              )
                                            );
                                          }
                                          let checkCpSelected =
                                            allCpDropDown.filter(
                                              ({ value }) => value === true
                                            );
                                          let indexOfMainList = findIndex(
                                            listOfDropDown,
                                            ({ label }) => label === 'CP'
                                          );
                                          if (checkCpSelected.length > 0) {
                                            setListOfDropDown((pre) => {
                                              pre[
                                                indexOfMainList
                                              ].select = true;
                                              return [...pre];
                                            });
                                            if (
                                              selectedListDropDown.find(
                                                (value) => value === 'CP'
                                              ) === undefined
                                            ) {
                                              setSelectedListDropDown((pre) => {
                                                return [...pre, 'CP'];
                                              });
                                            }
                                          } else {
                                            setListOfDropDown((pre) => {
                                              pre[
                                                indexOfMainList
                                              ].select = false;
                                              return [...pre];
                                            });
                                            setSelectedListDropDown((pre) => [
                                              ...pre.filter(
                                                (value) => value !== 'CP'
                                              ),
                                            ]);
                                          }
                                        }}
                                        control={
                                          <Checkbox
                                            sx={{
                                              '& .MuiSvgIcon-root': {
                                                fontSize: 28,
                                              },
                                            }}
                                          />
                                        }
                                        label={each.label}
                                      />
                                    </FormGroup>
                                  );
                                })
                              ) : (
                                <div className={cssClasses.label}>
                                  No CP Found
                                </div>
                              )}
                            </>
                          )}
                          {showAllSalesDropDown && (
                            <>
                              {allSalesDropDown?.length > 0 ? (
                                allSalesDropDown.map((each, index) => {
                                  return (
                                    <FormGroup>
                                      <FormControlLabel
                                        sx={[
                                          {
                                            '& .MuiTypography-root': {
                                              fontFamily:
                                                'Inter-Medium !important',
                                              fontStyle: 'normal',
                                              fontWeight: '400',
                                              fontSize: '1.6rem !important',
                                              lineHeight: '2.4rem !important',
                                              /* identical to box height, or 150% */

                                              /* Gray/900 */

                                              color: '#101828',
                                            },
                                          },
                                        ]}
                                        checked={each.value}
                                        onChange={(e) => {
                                          if (e.target.checked) {
                                            setAllSalesDropDown((pre) => {
                                              pre[index].value =
                                                e.target.checked;
                                              selectedSales.push(each.id);
                                              return [...pre];
                                            });
                                          } else {
                                            setAllSalesDropDown((pre) => {
                                              pre[index].value =
                                                e.target.checked;
                                              return [...pre];
                                            });
                                            setSelectedSales(
                                              selectedSales.filter(
                                                (id) => id !== each.id
                                              )
                                            );
                                          }
                                          let checkSalesSelected =
                                            allSalesDropDown.filter(
                                              ({ value }) => value === true
                                            );

                                      let indexOfMainList = findIndex(
                                        listOfDropDown,
                                        ({ label }) => label === 'SM'
                                      );
                                      if (checkSalesSelected.length > 0) {
                                        setListOfDropDown((pre) => {
                                          pre[indexOfMainList].select = true;
                                          return [...pre];
                                        });
                                        if (
                                          selectedListDropDown.find(
                                            (value) => value === 'SM'
                                          ) === undefined
                                        ) {
                                          setSelectedListDropDown((pre) => {
                                            return [...pre, 'SM'];
                                          });
                                        }
                                      } else {
                                        let indexOfMainList = findIndex(
                                          listOfDropDown,
                                          ({ label }) => label === 'SM'
                                        );
                                        setListOfDropDown((pre) => {
                                          pre[indexOfMainList].select = false;
                                          return [...pre];
                                        });
                                        setSelectedListDropDown((pre) => [
                                          ...pre.filter(
                                            (value) => value !== 'SM'
                                          ),
                                        ]);
                                      }
                                    }}
                                    control={
                                      <Checkbox
                                        sx={{
                                          '& .MuiSvgIcon-root': {
                                            fontSize: 28,
                                          },
                                        }}
                                      />
                                    }
                                    label={each.label}
                                  />
                                </FormGroup>
                                  );
                                })
                              ) : (
                                <div className={cssClasses.label}>
                                  No SM Found
                                </div>
                              )}
                             </>
                            )}
                         
                          {showAllProjectsDropDown && (
                          <>
                              {allProjectsDropDown?.length > 0 ? (
                          allProjectsDropDown.map((each, index) => {
                              return (
                                <FormGroup>
                                  <FormControlLabel
                                    sx={[
                                      {
                                        '& .MuiTypography-root': {
                                          fontFamily: 'Inter-Medium !important',
                                          fontStyle: 'normal',
                                          fontWeight: '400',
                                          fontSize: '1.6rem !important',
                                          lineHeight: '2.4rem !important',
                                          /* identical to box height, or 150% */

                                              /* Gray/900 */

                                          color: '#101828',
                                        },
                                      },
                                    ]}
                                    checked={each.value}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setAllProjectsDropDown((pre) => {
                                          pre[index].value = e.target.checked;
                                          selectedProjects.push(each.label);
                                          return [...pre];
                                        });
                                      } else {
                                        setAllProjectsDropDown((pre) => {
                                          pre[index].value = e.target.checked;
                                          return [...pre];
                                        });
                                        setSelectedProjects(
                                          selectedProjects.filter(
                                            (label) => label !== each.label
                                          )
                                        );
                                      }
                                      let checkProjectSelected =
                                        allProjectsDropDown.filter(
                                          ({ value }) => value === true
                                        );
                                      let indexOfMainList = findIndex(
                                        listOfDropDown,
                                        ({ label }) => label === 'Project'
                                      );
                                      if (checkProjectSelected.length > 0) {
                                        setListOfDropDown((pre) => {
                                          pre[indexOfMainList].select = true;
                                          return [...pre];
                                        });
                                        if (
                                          selectedListDropDown.find(
                                            (value) => value === 'Project'
                                          ) === undefined
                                        ) {
                                          selectedListDropDown.push('Project');
                                        }
                                      } else {
                                        setListOfDropDown((pre) => {
                                          pre[indexOfMainList].select = false;
                                          return [...pre];
                                        });
                                        setSelectedListDropDown([
                                          ...selectedListDropDown.filter(
                                            (value) => value !== 'Project'
                                          ),
                                        ]);
                                      }
                                    }}
                                    control={
                                      <Checkbox
                                        sx={{
                                          '& .MuiSvgIcon-root': {
                                            fontSize: 28,
                                          },
                                        }}
                                      />
                                    }
                                    label={each.label}
                                  />
                                </FormGroup>
                              );
                                })
                              ) : (
                                <div className={cssClasses.label}>
                                  No Projects Found
                                </div>
                              )}
                          </>
                          )}
                          {showAllLeadQualityDropDown &&
                            allLeadQualityDropDown.map((each, index) => {
                              return (
                                <FormGroup>
                                  <FormControlLabel
                                    sx={[
                                      {
                                        '& .MuiTypography-root': {
                                          fontFamily: 'Inter-Medium !important',
                                          fontStyle: 'normal',
                                          fontWeight: '400',
                                          fontSize: '1.6rem !important',
                                          lineHeight: '2.4rem !important',
                                          /* identical to box height, or 150% */

                                          /* Gray/900 */

                                          color: '#101828',
                                        },
                                      },
                                    ]}
                                    checked={each.value}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setAllLeadQualityDropDown((pre) => {
                                          pre[index].value = e.target.checked;
                                          selectedLeadQuality.push(each.label);
                                          return [...pre];
                                        });
                                      } else {
                                        setAllLeadQualityDropDown((pre) => {
                                          pre[index].value = e.target.checked;
                                          return [...pre];
                                        });
                                        setSelectedLeadQuality(
                                          selectedLeadQuality.filter(
                                            (label) => label !== each.label
                                          )
                                        );
                                      }
                                      let checkLeadQualitySelected =
                                        allLeadQualityDropDown.filter(
                                          ({ value }) => value === true
                                        );
                                      let indexOfMainList = findIndex(
                                        listOfDropDown,
                                        ({ label }) => label === 'Lead Quality'
                                      );
                                      if (checkLeadQualitySelected.length > 0) {
                                        setListOfDropDown((pre) => {
                                          pre[indexOfMainList].select = true;
                                          return [...pre];
                                        });
                                        if (
                                          selectedListDropDown.find(
                                            (value) => value === 'Lead Quality'
                                          ) === undefined
                                        ) {
                                          selectedListDropDown.push(
                                            'Lead Quality'
                                          );
                                        }
                                      } else {
                                        setListOfDropDown((pre) => {
                                          pre[indexOfMainList].select = false;
                                          return [...pre];
                                        });
                                        setSelectedListDropDown((pre) => [
                                          ...pre.filter(
                                            (value) => value !== 'Lead Quality'
                                          ),
                                        ]);
                                      }
                                    }}
                                    control={
                                      <Checkbox
                                        sx={{
                                          '& .MuiSvgIcon-root': {
                                            fontSize: 28,
                                          },
                                        }}
                                      />
                                    }
                                    label={each.label}
                                  />
                                </FormGroup>
                              );
                            })}
                          {showLeadTypeDropDown &&
                            leadTypeDropDown.map((each, index) => {
                              return (
                                <FormGroup>
                                  <FormControlLabel
                                    sx={[
                                      {
                                        '& .MuiTypography-root': {
                                          fontFamily: 'Inter-Medium !important',
                                          fontStyle: 'normal',
                                          fontWeight: '400',
                                          fontSize: '1.6rem !important',
                                          lineHeight: '2.4rem !important',
                                          color: '#101828',
                                        },
                                      },
                                    ]}
                                    checked={each.value}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setLeadTypeDropDown((pre) => {
                                          pre[index].value = e.target.checked;
                                          selectedLeadType.push(each.label);
                                          return [...pre];
                                        });
                                      } else {
                                        setLeadTypeDropDown((pre) => {
                                          pre[index].value = e.target.checked;
                                          return [...pre];
                                        });
                                        setSelectedLeadType(
                                          selectedLeadType.filter(
                                            (label) => label !== each.label
                                          )
                                        );
                                      }
                                      let checkLeadTypeSelected =
                                        leadTypeDropDown.filter(
                                          ({ value }) => value === true
                                        );
                                      let indexOfMainList = findIndex(
                                        listOfDropDown,
                                        ({ label }) => label === 'Lead Type'
                                      );
                                      if (checkLeadTypeSelected.length > 0) {
                                        setListOfDropDown((pre) => {
                                          pre[indexOfMainList].select = true;
                                          return [...pre];
                                        });
                                        if (
                                          selectedListDropDown.find(
                                            (value) => value === 'Lead Type'
                                          ) === undefined
                                        ) {
                                          selectedListDropDown.push('Lead Type');
                                        }
                                      } else {
                                        setListOfDropDown((pre) => {
                                          pre[indexOfMainList].select = false;
                                          return [...pre];
                                        });
                                        setSelectedListDropDown((pre) => [
                                          ...pre.filter(
                                            (value) => value !== 'Lead Type'
                                          ),
                                        ]);
                                      }
                                    }}
                                    control={
                                      <Checkbox
                                        sx={{
                                          '& .MuiSvgIcon-root': {
                                            fontSize: 28,
                                          },
                                        }}
                                      />
                                    }
                                    label={each.label}
                                  />
                                </FormGroup>
                              );
                            })}
                          {showAllStatusDropDown &&
                            allStatusDropDown.map((each, index) => {
                              return (
                                <FormGroup>
                                  <FormControlLabel
                                    sx={[
                                      {
                                        '& .MuiTypography-root': {
                                          fontFamily: 'Inter-Medium !important',
                                          fontStyle: 'normal',
                                          fontWeight: '400',
                                          fontSize: '1.6rem !important',
                                          lineHeight: '2.4rem !important',
                                          /* identical to box height, or 150% */

                                          /* Gray/900 */

                                          color: '#101828',
                                        },
                                      },
                                    ]}
                                    checked={each.value}
                                    onChange={(e) => {
                                      setAllStatusDropDown((pre) => {
                                        pre[index].value = e.target.checked;
                                        return [...pre];
                                      });
                                      if (e.target.checked) {
                                        setAllStatusDropDown((pre) => {
                                          pre[index].value = e.target.checked;
                                          selectedStatus.push(each.label);
                                          return [...pre];
                                        });
                                      } else {
                                        setAllStatusDropDown((pre) => {
                                          pre[index].value = e.target.checked;
                                          return [...pre];
                                        });
                                        setSelectedStatus(
                                          selectedStatus.filter(
                                            (status) => status !== each.label
                                          )
                                        );
                                      }
                                      let checkStatusSelected =
                                        allStatusDropDown.filter(
                                          ({ value }) => value === true
                                        );
                                      let indexOfMainList = findIndex(
                                        listOfDropDown,
                                        ({ label }) => label === 'Status'
                                      );
                                      if (checkStatusSelected.length > 0) {
                                        setListOfDropDown((pre) => {
                                          pre[indexOfMainList].select = true;
                                          return [...pre];
                                        });
                                        if (
                                          selectedListDropDown.find(
                                            (value) => value === 'Status'
                                          ) === undefined
                                        ) {
                                          selectedListDropDown.push('Status');
                                        }
                                      } else {
                                        setListOfDropDown((pre) => {
                                          pre[indexOfMainList].select = false;
                                          return [...pre];
                                        });
                                        setSelectedListDropDown([
                                          ...selectedListDropDown.filter(
                                            (value) => value !== 'Status'
                                          ),
                                        ]);
                                      }
                                    }}
                                    control={
                                      <Checkbox
                                        sx={{
                                          '& .MuiSvgIcon-root': {
                                            fontSize: 28,
                                          },
                                        }}
                                      />
                                    }
                                    label={each.label}
                                  />
                                </FormGroup>
                              );
                            })}
                          {showDates && (
                            <div>
                              <div className={cssClasses.dateDivider}>
                                <div className={cssClasses.label}>
                                  Start Date
                                </div>
                                <DateComponent
                                  value={selectDates[0].value}
                                  minDate={'1 Jan'}
                                  onChangeDate={(value) => {
                                    setSelectedDate('notNull');
                                    setSelectDates((pre) => {
                                      pre[0].value = value;
                                      return { ...pre };
                                    });
                                    setHelperText((pre) => {
                                      pre.endDate = '';
                                      return { ...pre };
                                    });
                                  }}
                                  helperText={helperText.startDate}
                                ></DateComponent>
                              </div>
                              <div>
                                <div className={cssClasses.label}>End Date</div>
                                <DateComponent
                                  value={selectDates[1].value}
                                  minDate={'1 Jan'}
                                  onChangeDate={(value) => {
                                    setSelectedDate('notNull');
                                    if (selectDates[0].value === '') {
                                      setHelperText((pre) => {
                                        pre.endDate =
                                          'Please select start date first';
                                        return { ...pre };
                                      });
                                    } else {
                                      if (selectDates[0].value > value) {
                                        setHelperText((pre) => {
                                          pre.endDate =
                                            'Select End Date Greater than start Date';
                                          return { ...pre };
                                        });
                                      } else {
                                        setSelectDates((pre) => {
                                          pre[1].value = value;
                                          return { ...pre };
                                        });
                                        setHelperText((pre) => {
                                          pre.endDate = '';
                                          return { ...pre };
                                        });
                                        let indexOfMainList = findIndex(
                                          listOfDropDown,
                                          ({ label }) => label === 'Date'
                                        );
                                        setListOfDropDown((pre) => {
                                          pre[indexOfMainList].select = true;
                                          return [...pre];
                                        });
                                        if (
                                          selectedListDropDown.find(
                                            (value) => value === 'Date'
                                          ) === undefined
                                        ) {
                                          selectedListDropDown.push('Date');
                                        }
                                      }
                                    }
                                  }}
                                  helperText={helperText.endDate}
                                ></DateComponent>
                              </div>
                            </div>
                          )}
                        </div>
                        <div className={cssClasses.wrapperDropDownButtons}>
                          <div>
                            <Button
                              style={{
                                color: '#344054',
                                backgroundColor: '#ffffff',
                                fontSize: '1.4rem',
                                lineHeight: '2rem',
                              }}
                              padding={'0.8rem'}
                              btnName={'Clear'}
                              clicked={() => {
                                clearFilters();
                                getAllLeads(
                                  0,
                                  sendTabValue,
                                  search,
                                  drpDownSelectedVal,
                                  selectDates,
                                  null,
                                  [],
                                  [],
                                  [],
                                  [],
                                  [],
                                  []
                                );
                              }}
                            />
                          </div>
                          <div>
                            <Button
                              style={{
                                color: '#ffffff',
                                backgroundColor: '#1570EF',
                                fontSize: '1.4rem',
                                lineHeight: '2rem',
                              }}
                              padding={'0.8rem'}
                              btnName={'Apply'}
                              clicked={() => {
                                if (
                                  selectDates[1].value === '' &&
                                  selectedDates !== null
                                ) {
                                  setHelperText((pre) => {
                                    pre.endDate = 'Please Select end Date';
                                    return { ...pre };
                                  });
                                  setShowDates(true);
                                } else {
                                  setHelperText((pre) => {
                                    pre.endDate = '';
                                    return { ...pre };
                                  });
                                  setShowDates(false);
                                }

                                setShowAllSalesDropDown(false);
                                setShowAllProjectsDropDown(false);
                                setShowAllLeadQualityDropDown(false);
                                setShowAllStatusDropDown(false);
                                setShowLeadTypeDropdown(false);
                                setShowDropDown(false);
                                if (
                                  helperText.startDate === '' &&
                                  helperText.endDate === ''
                                ) {
                                  setLeadArray([]);
                                  setShowDropDown(false);
                                  getAllLeads(
                                    0,
                                    sendTabValue,
                                    search,
                                    drpDownSelectedVal,
                                    selectDates,
                                    selectedDates,
                                    selectedCP,
                                    selectedSales,
                                    selectedProjects,
                                    selectedLeadQuality,
                                    selectedStatus,
                                    selectedLeadType
                                  );
                                } else {
                                  setShowDropDown(true);
                                }
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ClickAwayListener>
              )}
            </div>
          </div>
          <div className={cssClasses.wrapperSortDropDown}>
            {/* <div>Filter By</div> */}
            <div className={cssClasses.filterTitle}>Sort by</div>
            <DropDown
              list={[
                'Name Ascending',
                'Name Descending',
                'Latest First',
                'Oldest First',
              ]}
              selectedValue={drpDownSelectedVal}
              onChangeSelect={(_value) => {
                setDrpDownSelectedVal(_value);
                setLeadArray([]);
                getAllLeads(
                  0,
                  sendTabValue,
                  search,
                  _value,
                  selectDates,
                  selectedDates,
                  selectedCP,
                  selectedSales,
                  selectedProjects,
                  selectedLeadQuality,
                  selectedStatus,
                  selectedLeadType
                );
              }}
              placeHolder={'Select'}
              //style.color is placeHolder's color
              style={{
                background: '#F2F4F7',
                color: 'rgb(102, 112, 133)',
                minWidth: '180px',
              }}
              helperText={''}
            />
          </div>
        </div>
        <div className={cssClasses.wrapperSearchBar}>

          <SearchBar
            id={'leadSearch'}
            placeholder={'Search'}
            search={debouncedFetchSearchData}
            // search={e => setSearch(e.target.value)}
            width='100%'
            // value={search || ''}

          />
        </div>
      </div>
      {/* Multi-select / claim actions don't apply to Lost leads (only Regenerate). */}
      {tabValue !== 'Lost' && (
      <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", gap: "1rem", marginBottom: "8px" }}>
        {!selectMultipleLeads ? <div className={cssClasses.wrapperSortDropDown}>
          <Button
            style={{
              color: "#fff",
              backgroundColor: "#1570EF",
              fontSize: "1.4rem",
              lineHeight: "2rem",
              fontFamily: "Inter-Medium !important",
            }}
            btnName="Select Multiple Leads"
            clicked={() => {
              let tempAction = [];
              dropDownList.forEach((el) => {
                const isAccessible = loggedInUser?.roleId?.accessibleTabs?.Leads?.[tabValue]?.[el]?.isAccessible;
                if (tabValue === "Unclaimed" || tabValue === "All") {
                  if (el === "Claim Leads") {
                    if (loggedInUser?.roleId?.accessibleTabs?.Leads?.Unclaimed?.Claimed
                      ?.isAccessible) {
                      tempAction.push(el);
                    }
                  }
                  if (el === "Assign Lead") {
                    if (isAccessible) {
                      tempAction.push(`${el}`);
                    }
                  }
                }
                if (el === "Reassign Lead" && tabValue !== "Unclaimed") {
                  if (isAccessible) {
                    tempAction.push(`${el}`);
                  }
                }
              })
              if (tempAction.length === 0) {
                tempAction.push("No Action Available");
              }
              setLeadsAction(tempAction);
              setSelectMultipleLeads(true)
            }}

          />
        </div> :
          <div className={cssClasses.leadsCount}>
            {leadArray.filter((e) => {
              return e.isSelected === true;
            }).length} Selected Leads
          </div>

        }
        {selectMultipleLeads && <div style={{ display: "flex", flexDirection: "row", justifyContent: "flex-end", gap: "1rem" }}>
          <div style={{ display: "flex", flexDirection: "row", gap: "1rem", alignItems: "center" }}>
            <div style={{
              fontFamily: 'Inter-Medium',
              fontStyle: 'normal',
              fontWeight: '400',
              fontSize: '1.6rem',
              lineHeight: '2.4rem',
              color: '#101828',
            }}>Select All</div>
            <Checkbox sx={{
              '& .MuiSvgIcon-root': {
                fontSize: 28,
              },
            }}
              onChange={() => {
                setLeadArray((prev) =>
                  prev.map((item) => ({
                    ...item,
                    isSelected: true,
                  }))
                );
              }}
              checked={
                leadArray.length ===
                leadArray.filter((e) => {
                  return e.isSelected === true;
                }).length
              }
            /></div>
          <div style={{ display: "flex", flexDirection: "row", gap: "1rem", alignItems: "center" }}>
            <div style={{
              fontFamily: 'Inter-Medium',
              fontStyle: 'normal',
              fontWeight: '400',
              fontSize: '1.6rem',
              lineHeight: '2.4rem',
              color: '#101828',
            }} >Deselect All</div>
            <Checkbox sx={{
              '& .MuiSvgIcon-root': {
                fontSize: 28,
              },
            }}
              onChange={() => {
                setLeadArray((prev) =>
                  prev.map((item) => ({
                    ...item,
                    isSelected: false,
                  }))
                );
              }}
              checked={
                leadArray.length ===
                leadArray.filter((e) => {
                  return e.isSelected === false;
                }).length
              }
            /><div>
              <ThreeDotsMenu
                list={leadsAction}
                selectedValue={(e) => {
                  handleSelectedLeads(e);
                }}
              /></div>
          </div>
          <div >
            <Button
              style={{
                color: "#1570EF",
                backgroundColor: "#fff",
                fontSize: "1.4rem",
                lineHeight: "2rem",
                fontFamily: "Inter-Medium !important",
              }}
              btnName={"Cancel"}
              clicked={() => {
                setSelectMultipleLeads(false)
              }}
            />
          </div>
        </div>}
      </div>
      )}
      <div
        className={cssClasses.wrapperLeads}
        id='scrollableDiv'
        // onScroll={onScroll}
        // ref={scrollRef}
      >
        {tabValue === 'Lost' ? (
          <LostLeads
            filters={{
              search,
              sort: drpDownSelectedVal,
              projects: Array.isArray(selectedProjects) ? selectedProjects : (selectedProjects ? [selectedProjects] : []),
              salesIds: selectedSales,
              cpIds: selectedCP,
              leadTypes: selectedLeadType,
              leadResponses: selectedLeadQuality,
              dateFrom: selectDates?.[0]?.value ? new Date(selectDates[0].value).getTime() : undefined,
              dateTo: selectDates?.[1]?.value ? new Date(selectDates[1].value).getTime() : undefined,
            }}
          />
        ) : (
        <>
        <InfiniteScroll
          dataLength={leadArray.length}
          next={getMoreData}
          style={{ display: 'flex', flexDirection: 'column' }} //To put endMessage and loader to the top.
          hasMore={loadingStatus === 0}
          // loader={<h4>Loading...</h4>}
          scrollableTarget='scrollableDiv'
        >
          {uniqBy(leadArray, 'leadId').map((each, index) => {
            return (
              <div className={cssClasses.wrapperLead} key={index}>
                <Leadcard
                  leadObj={each}
                  claimLead={(e) => {
                    claimLead(each);
                  }}
                  tabValue={sendTabValue}
                  returnResLeads={funReturnRes}
                  onSelecting={() => {
                    setLeadArray((prev) => {
                      const newArray = [...prev];
                      newArray[index] = {
                        ...newArray[index],
                        isSelected: !newArray[index].isSelected,
                      };
                      return newArray;
                    });
                  }}
                  selectMultipleLeads={selectMultipleLeads}
                />
              </div>
            );
          })}
        </InfiniteScroll>
        {noLeadsPresent === false && (
          <div className={cssClasses.noDataMsg}>
            <div className={cssClasses.emptyIcon}>
              <img src={EmptyListIcon} alt='No Leads' />
            </div>
            <div className={cssClasses.emptyTitle}>No leads found</div>
            <div className={cssClasses.emptySubTitle}>
              To add a new lead, click on
              {loggedInUser?.roleId?.accessibleTabs?.Leads?.['Add Leads']
                ?.isAccessible && (
                <div className={cssClasses.addLeadBtn}>
                  <Button
                    style={{
                      color: '#fff',
                      backgroundColor: '#175CD3',
                      fontSize: '1.6rem',
                      lineHeight: '2.4rem',
                    }}
                    btnName={'Add Leads'}
                    clicked={() => {
                      setAddLeadModal(true);
                    }}
                    btnIcon={<PlusIcon />}
                    iconPosition={'left'}
                  >
                    {' '}
                  </Button>
                </div>
              )}
              {/* to add a new Lead */}
            </div>
          </div>
        )}
        </>
        )}
      </div>
      {addLeadModal && (
        <AddLead
          open={addLeadModal}
          handleClose={() => {
            setAddLeadModal(false);
          }}
          leadAddedResp={leadAdded}
        />
      )}
      {reAssignLeadModal && (
        <ReAssignLead
          open={reAssignLeadModal}
          handleClose={() => {
            setReAssignLeadModal(false);
          }}
          data={selectedLeads}
          modalTitle={assignTitle}
          returnRes={returnRes}
          from='leadtab'
        />
      )}
    </div>
  );
}
